<div class="mat-dialog-custom confirmation-dialog" [id]="options.dialogId">
  @if (options.titleText) {
    <div class="title-container">
      <h1 class="title">{{ options.titleText }}</h1>
      @if (options.showCloseButton) {
        <div>
          <a
            href="javascript:void(0)"
            aria-label="close"
            mat-dialog-close="cancel"
            [id]="options.closeButtonId"
            i18n-aria-label
          >
            <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
          </a>
        </div>
      }
    </div>
  }

  @if (options.contentText) {
    <div class="body-container">
      <div [innerHTML]="options.contentText"></div>
      @if (!options.hideAppStoreButtons) {
        <div class="store-buttons-container">
          <div class="app-store">
            <a id="appStore" target="_blank" [href]="appStoreUrl">
              <img class="" alt="App Store" ngSrc="/assets/images/apple-app-store.svg" i18n-alt />
            </a>
          </div>
          <div class="google-play">
            <a id="googlePlay" target="_blank" [href]="playStoreUrl">
              <img class="" alt="Google Play" ngSrc="/assets/images/google-play-store.svg" i18n-alt />
            </a>
          </div>
        </div>
      }

      <div class="buttons-container">
        <div class="left">
          <button
            class="button primary-button helper-full-width"
            type="submit"
            mat-dialog-close="confirm"
            [id]="options.confirmButtonId"
          >
            {{ options.confirmText }}
          </button>
        </div>
        @if (!options.hideCancelButton) {
          <div class="right">
            <button
              class="button secondary-button cancel"
              type="button"
              mat-dialog-close="cancel"
              [id]="options.cancelButtonId"
            >
              {{ options.cancelText }}
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
